import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const UploadError = ({
  size,
  type,
  theme,
  className,
  dataTestId = "upload-error",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M10.401 9.38c.262.26.264.682.004.943l-1.93 1.94a.664.664 0 0 1-.947-.004l-1.93-1.952a.667.667 0 1 1 .947-.936l.79.799V6.873a.667.667 0 0 1 1.333 0v3.302l.79-.794c.26-.261.682-.261.943-.001Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.173 1.401a1.333 1.333 0 0 0-2.341 0L.487 13.031a1.333 1.333 0 0 0 1.17 1.972h12.688a1.333 1.333 0 0 0 1.17-1.972L9.173 1.401Zm-1.171.639L1.658 13.67h12.688L8.002 2.04Z"
    />
  </SVGIcon>
);
